// services/getSaleService.js
import api from './api';
import AuthService from './authService';

class GetSaleService {
  /**
   * Get sales data with pagination and filters
   */
  getSales = async (page = 1, limit = 10, search = '', startDate = '', endDate = '') => {
    try {
      const user = AuthService.getCurrentUser();
      
      if (!user) {
        throw new Error('User not authenticated');
      }

      const params = {
        page,
        limit,
      };

      // Add optional filters if provided
      if (search && search.trim() !== '') {
        params.search = search.trim();
      }
      
      if (startDate) {
        params.startDate = startDate;
      }
      
      if (endDate) {
        params.endDate = endDate;
      }

      const response = await api.get('/sales/user/invoice', { params });
      
      if (response.data.success) {
        return response.data;
      } else {
        throw new Error(response.data.message || 'Failed to fetch sales');
      }

    } catch (error) {
      console.error('Error fetching sales:', error);
      
      if (error.response?.status === 401) {
        AuthService.logout();
        throw new Error('Session expired. Please login again.');
      }
      
      throw new Error(error.response?.data?.message || error.message || 'Failed to fetch sales data');
    }
  };
}

export default new GetSaleService();
